<template>
    <div class="list_wrap">
        <template v-if="!loading">
            <div class="list_wrap_mobile">
                <div class="content_title">{{menuName}}</div>
                <div v-if="listLoading" class="loading"></div>
                <div class="list" v-else-if="list.length > 0">
                    <router-link class="item" v-for="item in list" :key="item.id" :to="`detail/${item.id}`" append>
                        <p class="title">{{item.title}}</p>
                        <p class="time">{{item.time}}</p>
                    </router-link>
                </div>
                <div v-else class="nothing">{{$t('nothing')}}</div>
            </div>
            <Pagination :page="allPage" @change="changePage"/>
        </template>
        <div v-else class="loading"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Pagination from '../components/pagination.vue';
export default {
    name: "list",
    data() {
        return {
            loading: false,
            list: [],
            listLoading: false,
            allPage: 1,
            nowPage: 1,
            limit: 10,
        };
    },
    computed: {
        ...mapState(['menuName']),
    },
    components: {
        Pagination
        
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {
        '$route.params.id': {
            handler: function(){
                this.loading = true;
                this.allPage = 1;
                this.nowPage = 1;
                this.getList();
            },
            immediate: true
        }
    },
    methods: {
        getList(){
            this.listLoading = true;
            this.list = [];
            this.$store.dispatch('getList', {
                id: this.$route.params.id,
                page: this.nowPage,
                limit: this.limit,
            }).then((result)=>{
                this.loading = false;
                this.listLoading = false;
                this.list = result.list;
                this.allPage = result.last_page;
                this.nowPage = result.current_page;
            });
        },
        changePage(page){
            this.nowPage = page;
            this.getList();
        },
    },
};
</script>

<style scoped lang="scss">
.list_wrap{
    width: 910px;
    margin-left: 56px;
    .list{
        .item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px dashed #a5a5a5;
            font-size: 16px;
            color: #434c5c;
            line-height: 2.5;
            .title{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
            }
            .time{
                color: rgba(0,0,0,.5);
                white-space: nowrap;
                margin-left: 20px;
            }
            &:hover{
                color: #00a2d4;
                .time{
                    color: #00a2d4;
                }
            }
        }
    }
    @media only screen and (max-width: 1024px) {
        width: 100%;
        margin: 0;
        .list_wrap_mobile{
            border: 1px solid #e8eaed;
            border-radius: .1rem;
        }
        .list{
            padding: .4rem;
            .item{
                border-bottom: none;
                font-size: .24rem;
                line-height: .3rem;
                margin-bottom: .3rem;
                &:last-child{
                    margin-bottom: 0;
                }
                .time{
                    color: #9c9c9c;
                    padding-left: .4rem;
                    background: url('~@/assets/images/1_28.png') no-repeat;
                    background-position: center left;
                    background-size: .26rem;
                    margin-left: .2rem;
                }
            }
        }
    }
}
</style>